import React, { useRef, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Input, InputLabel, Button, Switch, CircularProgress } from "@mui/material";
import { FormControl, FormGroup, FormControlLabel } from "@mui/material";
import { ThemeModeContext, contentBoxStyle } from "../shared/Theme";
import { Link } from "react-router-dom";
import userService from "../services/userService";
import alertService from "../services/alertService";

const Login = () => {
	
	let [ step, setStep ] = useState(0);
	let [ remember, setRemember ] = useState(true);
	let [ loading, setLoading ] = useState(false);
	
	const navigate = useNavigate();
	
	const themeModeContext = useContext(ThemeModeContext);
	const imageUrls = {
		"light": "/cymplify-logo_light.png",
		"dark": "/cymplify-logo_dark.png",
	}
	const imageUrl = imageUrls[themeModeContext.themeMode];
	
	const email = useRef(null);
	const password = useRef(null);
	const code = useRef(null);

	const handleSubmit = (e) => {
		e.preventDefault();
		
		let emailValue = (email.current)? email.current.value : null;
		let passwordValue = (password.current)? password.current.value : null;
		let codeValue = (code.current)? code.current.value : null;
		
		setLoading(true);
		
		userService.login(emailValue, passwordValue, codeValue, remember)
		.then((newStep) => {
			setLoading(false);
			
			if (password.current) password.current.value = "";
			if (code.current) code.current.value = "";
			
			if (newStep === 2) {
				navigate("/");
				return;
			}
			
			setStep(newStep);
		})
		.catch((err) => {
			if (email.current) email.current = emailValue;
			if (password.current) password.current.value = "";
			if (code.current) code.current.value = "";
			
			setLoading(false);
			setStep(0);
			
			setTimeout(() => {
				alertService.show("Incorrect email/password combination");
			}, 100);
		});
	};

	const formControlStyle = {
		width: "80%",
		height: "100%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	const inputStyle = {
		padding: "0 1em"
	};
	
	const handleRememberSwitch = (event) => {
		setRemember(event.target.checked);
	};
		
	return (
		<Box sx={{ display: "flex" }}>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Box sx={contentBoxStyle}>
					<Box sx={{
						height: "30em",
						width: "25em",
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)"
					}}>
						<Box sx={{ textAlign: "center", marginTop: "2em" }}>
							<Link to="/">
								<img src={imageUrl} alt="cymplify logo" />
							</Link>
						</Box>
						{ loading &&
							<Box sx={{ textAlign: "center", marginTop: "2em", marginBottom: "1em" }}>
								<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
							</Box>
						}
						{ !loading &&
							<form onSubmit={handleSubmit}>
								{step === 0 &&
									<Box sx={{ textAlign: "center", marginTop: "2em", marginBottom: "1em" }}>
										<Typography>Please sign in with your Cymplify account</Typography>
									</Box>
								}
								{step === 1 &&
									<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
										<Typography>A verifications code has been emailed to you</Typography>
									</Box>
								}
								{step === 0 &&
									<FormControl sx={formControlStyle}>
										<InputLabel htmlFor="email">Email</InputLabel>
										<Input inputRef={email} id="email" type="email" inputProps={{ sx: {inputStyle}}}/>
									</FormControl>
								}
								{step === 0 &&
									<FormControl sx={formControlStyle}>
										<InputLabel htmlFor="password">Password</InputLabel>
										<Input inputRef={password} id="password" type="password"/>
									</FormControl>
								}
								{step === 0 &&
									<FormGroup sx={formControlStyle}>
										<FormControlLabel
											control={
												<Switch
													checked={remember}
													onChange={handleRememberSwitch}
												/>
											}
											label="Remember Me?"
										/>
									</FormGroup>
								}
								{step === 1 &&
									<FormControl sx={formControlStyle}>
										<InputLabel htmlFor="email">Verification Code</InputLabel>
										<Input inputRef={code} id="code" type="text" inputProps={{ sx: {inputStyle}}}/>
									</FormControl>
								}
								<FormControl sx={formControlStyle}>
									<Button type="submit" label="Sign In">Sign In</Button>
								</FormControl>
								{step === 0 &&
									<Link to="/forgot" style={{textDecoration: "none", textAlign: "center"}}>
										<Typography sx={{color: "text.link"}}>Forgot your password?</Typography>
									</Link>
								}
							</form>
						}
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export default Login;
